// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__j4e2A","container":"Footer_container__Kh4aL","year":"Footer_year__L6Tx+"};